export const getFullOSName = (osName) => {
  switch (osName?.toLowerCase()) {
    case 'win':
      return 'Windows';

    case ('mac'):
      return 'MacOS';
    
    case ('cros'):
      return 'Chrome OS';
    
    case ('lin'):
      return 'Linux';
    
    default:
      return osName;
  }
};